<template>
  <div>123</div>
</template>

<script>
export default {
  name: 'index-page',
  data() {
    return {

    }
  }
}
</script>

<style>

</style>